import SettingsPage from './SettingsPage'
// Uncomment the below to migrate to stateful component
// import SettingsPageContainer from './SettingsPageContainer'

export { SettingsPage }
export default SettingsPage
// Uncomment the below to migrate to stateful component
// export { SettingsPage, SettingsPageContainer }
// export default SettingsPageContainer



// WEBPACK FOOTER //
// ./src/pages/SettingsPage/index.js